var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMedal2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 66,
    height: 66,
    viewBox: "0 0 66 66",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_103_7734)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M30.244 5.92234C31.7742 4.3282 34.3237 4.3282 35.854 5.92234L36.5321 6.6288C37.4849 7.62137 38.8914 8.0365 40.2304 7.72041L41.1735 7.4978C43.3152 6.99224 45.4493 8.36329 45.8798 10.5214L46.0869 11.5596C46.3537 12.8971 47.3018 13.997 48.5854 14.4582L49.5637 14.8096C51.619 15.548 52.6632 17.8339 51.8757 19.8708L51.4741 20.9098C50.9859 22.1727 51.1898 23.5986 52.0125 24.6741L52.6859 25.5544C54.0098 27.2852 53.6531 29.766 51.895 31.0536L51.0231 31.6922C49.9278 32.4944 49.3302 33.8098 49.4466 35.1625L49.5406 36.2538C49.7285 38.4376 48.0752 40.3451 45.8868 40.4692L44.8905 40.5257C43.522 40.6033 42.2955 41.3956 41.6623 42.6112L41.1931 43.5117C40.1734 45.4693 37.7304 46.1863 35.8144 45.0905L34.9794 44.6129C33.7834 43.9289 32.3146 43.9289 31.1186 44.6129L30.2836 45.0905C28.3675 46.1863 25.9246 45.4693 24.9048 43.5117L24.4357 42.6112C23.8025 41.3956 22.576 40.6033 21.2075 40.5257L20.2112 40.4692C18.0228 40.3451 16.3695 38.4376 16.5574 36.2538L16.6513 35.1625C16.7678 33.8098 16.1702 32.4944 15.0749 31.6922L14.203 31.0536C12.4449 29.766 12.0882 27.2852 13.4121 25.5544L14.0855 24.6741C14.9082 23.5986 15.1121 22.1727 14.6239 20.9098L14.2223 19.8708C13.4348 17.8339 14.479 15.548 16.5343 14.8097L17.5126 14.4582C18.7962 13.997 19.7443 12.8971 20.0111 11.5596L20.2182 10.5214C20.6487 8.36329 22.7828 6.99224 24.9245 7.4978L25.8676 7.72041C27.2066 8.0365 28.613 7.62137 29.5658 6.6288L30.244 5.92234Z",
    fill: "url(#paint0_linear_103_7734)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.244 5.92234C31.7742 4.3282 34.3237 4.3282 35.854 5.92234L36.5321 6.6288C37.4849 7.62137 38.8914 8.0365 40.2304 7.72041L41.1735 7.4978C43.3152 6.99224 45.4493 8.36329 45.8798 10.5214L46.0869 11.5596C46.3537 12.8971 47.3018 13.997 48.5854 14.4582L49.5637 14.8096C51.619 15.548 52.6632 17.8339 51.8757 19.8708L51.4741 20.9098C50.9859 22.1727 51.1898 23.5986 52.0125 24.6741L52.6859 25.5544C54.0098 27.2852 53.6531 29.766 51.895 31.0536L51.0231 31.6922C49.9278 32.4944 49.3302 33.8098 49.4466 35.1625L49.5406 36.2538C49.7285 38.4376 48.0752 40.3451 45.8868 40.4692L44.8905 40.5257C43.522 40.6033 42.2955 41.3956 41.6623 42.6112L41.1931 43.5117C40.1734 45.4693 37.7304 46.1863 35.8144 45.0905L34.9794 44.6129C33.7834 43.9289 32.3146 43.9289 31.1186 44.6129L30.2836 45.0905C28.3675 46.1863 25.9246 45.4693 24.9048 43.5117L24.4357 42.6112C23.8025 41.3956 22.576 40.6033 21.2075 40.5257L20.2112 40.4692C18.0228 40.3451 16.3695 38.4376 16.5574 36.2538L16.6513 35.1625C16.7678 33.8098 16.1702 32.4944 15.0749 31.6922L14.203 31.0536C12.4449 29.766 12.0882 27.2852 13.4121 25.5544L14.0855 24.6741C14.9082 23.5986 15.1121 22.1727 14.6239 20.9098L14.2223 19.8708C13.4348 17.8339 14.479 15.548 16.5343 14.8097L17.5126 14.4582C18.7962 13.997 19.7443 12.8971 20.0111 11.5596L20.2182 10.5214C20.6487 8.36329 22.7828 6.99224 24.9245 7.4978L25.8676 7.72041C27.2066 8.0365 28.613 7.62137 29.5658 6.6288L30.244 5.92234Z",
    fill: "url(#paint1_linear_103_7734)",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.7617 25.3476C17.7617 16.9047 24.6061 10.0604 33.049 10.0604C41.4919 10.0604 48.3362 16.9047 48.3362 25.3476V25.662C48.3362 34.1049 41.4919 40.9493 33.049 40.9493C24.6061 40.9493 17.7617 34.105 17.7617 25.662V25.3476Z",
    fill: "black",
    fillOpacity: 0.04
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.2135 25.3476C19.2135 17.7065 25.4079 11.5121 33.049 11.5121C40.6901 11.5121 46.8845 17.7065 46.8845 25.3476V25.662C46.8845 33.3032 40.6901 39.4975 33.049 39.4975C25.4078 39.4975 19.2135 33.3032 19.2135 25.662V25.3476Z",
    stroke: "white",
    strokeOpacity: 0.3,
    strokeWidth: 2.90353
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.5298 28.2957L27.5945 25.3302C27.4364 25.1702 27.2219 25.0802 26.9981 25.0802C26.7743 25.0802 26.5598 25.1702 26.4017 25.3302C26.0718 25.6635 26.0718 26.2019 26.4017 26.5352L29.9376 30.1075C30.2676 30.4408 30.8005 30.4408 31.1304 30.1075L40.0801 21.0657C40.4101 20.7324 40.4101 20.194 40.0801 19.8607C39.9221 19.7007 39.7075 19.6107 39.4838 19.6107C39.26 19.6107 39.0455 19.7007 38.8874 19.8607L30.5298 28.2957Z",
    fill: "white",
    stroke: "#FDFDFD",
    strokeWidth: 0.580707
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.0496 11.7459C33.0496 10.8651 33.7655 10.1425 34.6417 10.233C37.408 10.5188 40.057 11.5453 42.3032 13.2179C44.9775 15.2093 46.938 18.0102 47.8935 21.2045C48.8491 24.3989 48.7487 27.8162 47.6073 30.949C46.4659 34.0817 44.3443 36.7627 41.5578 38.5937C38.7713 40.4246 35.4685 41.3078 32.14 41.1121C28.8116 40.9163 25.6351 39.6521 23.0823 37.5072C20.5296 35.3623 18.7369 32.4512 17.9705 29.2063C17.3268 26.4807 17.436 23.6418 18.2716 20.9893C18.5363 20.1492 19.4837 19.7788 20.2922 20.1284C21.1007 20.478 21.4617 21.4154 21.2196 22.2623C20.6433 24.2776 20.5891 26.416 21.0749 28.4731C21.6835 31.05 23.1072 33.3618 25.1343 35.0651C27.1615 36.7684 29.6841 37.7723 32.3273 37.9278C34.9705 38.0832 37.5933 37.3818 39.8062 35.9278C42.019 34.4738 43.7038 32.3448 44.6102 29.857C45.5166 27.3692 45.5963 24.6554 44.8375 22.1187C44.0787 19.582 42.5218 17.3577 40.3981 15.7763C38.7028 14.5139 36.7186 13.715 34.6401 13.444C33.7666 13.3302 33.0496 12.6268 33.0496 11.7459Z",
    fill: "white",
    fillOpacity: 0.5
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_103_7734",
    x: -1,
    y: -1,
    width: 68.0977,
    height: 68.098,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 8
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 6
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.917647 0 0 0 0 0.690196 0 0 0 0 0.12549 0 0 0 0.4 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_103_7734"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_103_7734",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_103_7734",
    x1: 18.743,
    y1: 7.12981,
    x2: 42.9305,
    y2: 45.2547,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE092"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E3A302"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_103_7734",
    x1: 3.42686,
    y1: -0.444926,
    x2: 36.9252,
    y2: 59.3466,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMedal2);
export default __webpack_public_path__ + "static/media/medal2.84cc4c437735ff4410e5d5c9c7df023b.svg";
export { ForwardRef as ReactComponent };